







































































































































import {
	computed,
	defineComponent,
	ref,
	watchEffect,
} from '@vue/composition-api';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { getUsername } from '@front-app/util/user';
import { Routes } from '@front-app/constants/routes';
import { Size } from '@front-app/components/constants';
import { CurrentUserStore, UserAvatarStore } from '@front-app/store/singletons/User';
import TrButton from '@front-app/components/buttons/TrButton.vue';
import SimpleDropdown from '@front-app/components/dropdowns/SimpleDropdown.vue';
import DropdownDivider from '@front-app/components/dropdowns/DropdownDivider.vue';
import UserAvatar from '@front-app/components/user/avatar.vue';
import PublicLink from '@front-app/components/buttons/PublicLink.vue';
import HeaderLink from './HeaderLink.vue';

const legal = [
	{
		text: 'links.privacy-policy',
		href: `${
			process.env.VUE_APP_TRAPP_PUBLIC_URL
		}/legal/timedright-privacy-policy`,
	},
	{
		text: 'terms-of-use',
		href: `${process.env.VUE_APP_TRAPP_PUBLIC_URL}/legal/website-terms-of-use`,
	},
	{
		text: 'links.trademarks-and-copyright',
		href: `${
			process.env.VUE_APP_TRAPP_PUBLIC_URL
		}/legal/trademark-and-copyright-usage-policy`,
	},
];

const toSettings = { name: Routes.USER_SETTINGS };
const toCsr = { name: Routes.CSR };
const toLearningPrograms = { name: Routes.USER_LEARNING_PROGRAMS };

export default defineComponent({
	components: {
		PublicLink,
		HeaderLink,
		SimpleDropdown,
		DropdownDivider,
		FontAwesomeIcon,
		UserAvatar,
	},
	setup(props, ctx) {
		const isUserMenuOpen = ref(false);
		const { currentUser } = CurrentUserStore;
		const displayName = computed(() => getUsername(ctx.root.$t.bind(ctx.root), currentUser.value));

		watchEffect(() => {
			UserAvatarStore.fetch(currentUser.value.id);
		});
		const toMyProfile = computed(() => ({ name: Routes.USER_PROFILE, params: { userId: currentUser.value.id } }));

		const navigateAndClose = (e: Event, navigate: (e: Event) => void) => {
			navigate(e);
			isUserMenuOpen.value = false;
		};

		return {
			Size,
			legal,
			TrButton,
			toMyProfile,
			toCsr,
			toSettings,
			toLearningPrograms,
			isUserMenuOpen,
			displayName,
			navigateAndClose,
			isCsr: CurrentUserStore.isCsr,
			getImage: () => UserAvatarStore.get(CurrentUserStore.currentUser.value.id),
			currentUser: CurrentUserStore.currentUser,
			version: process.env.VUE_APP_VERSION,
			hash: process.env.VUE_APP_COMMITHASH,
			year: new Date().getFullYear(),
			logout() {
				CurrentUserStore.actions.logOut(ctx.root.$route, ctx.root.$router);
			},
		};
	},
});
